import React from "react";
import { Route } from "react-router-dom";
import ProductDetails from "../product/ProductDetail";
import Login from "../auth/Login";
import Register from "../auth/Register";
import Profile from "../user/Profile";
import UpdateProfile from "../user/UpdateProfile";
import ProtectedRoute from "../auth/ProtectedRoute";
import UploadAvatar from "../user/UploadAvatar";
import UpdatePassword from "../user/UpdatePassword";
import ForgotPassword from "../auth/ForgotPassword";
import ResetPassword from "../auth/RestsetPassword";
import Cart from "../cart/Cart";
import Shipping from "../cart/Shipping";
import ConfirmOrder from "../cart/ConfirmOrder";
import PaymentMethod from "../cart/PaymentMethod";
import MyOrders from "../order/MyOrders";
import OrderDetails from "../order/OrderDetails";
import Invoice from "../invoice/Invoice";
import Home from "../Home.jsx";
import AboutUs from "../test/aboutus";
import OurCakes from "../OurCakes";
import VeggieDelights from "../test/VeggieDelights";
import DeliveryPickupService from "../test/deliveryservice";
import ForallQuestion from "../test/ForallQuestion.jsx";
import StripePaymentError from "../test/error.jsx";
import OrderForm from "../test/pos.jsx";
import ListNewStores from "../test/stores.jsx"
import EditStore from "../test/storeorder.jsx"
const userRoutes = () => {
  return (
    <>
      <Route path="/faq" element={<ForallQuestion />} />
      <Route path="/delivery" element={<DeliveryPickupService />} />
      <Route path="/" element={<Home />} />
      <Route path="/decline" element={<StripePaymentError />} />
      <Route path="/home" element={<Home />} />
      <Route path="/pos" element={<OrderForm />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/product/:id" element={<ProductDetails />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/ourcakes" element={<OurCakes />} />
      <Route path="/password/forgot" element={<ForgotPassword />} />
      <Route path="/reset/:token" element={<ResetPassword />} />

      <Route
        path="/me/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />

      <Route
        path="/me/update_profile"
        element={
          <ProtectedRoute>
            <UpdateProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/me/uploadAvatar"
        element={
          <ProtectedRoute>
            <UploadAvatar />
          </ProtectedRoute>
        }
      />
      <Route
        path="/me/update_password"
        element={
          <ProtectedRoute>
            <UpdatePassword />
          </ProtectedRoute>
        }
      />
      <Route path="/cart" element={<Cart />} />
      <Route path="/shipping" element={<Shipping />} />
      <Route path="/confirm_order" element={<ConfirmOrder />} />
      <Route path="/payment_method" element={<PaymentMethod />} />
      <Route
        path="/me/orders"
        element={
          <ProtectedRoute>
            <MyOrders />
          </ProtectedRoute>
        }
      />
      <Route
        path="/me/order/:id"
        element={
          <ProtectedRoute>
            <OrderDetails />
          </ProtectedRoute>
        }
      />
      

      <Route path="/store/order" element={<ListNewStores/>} />
      <Route path="/store/orderupdate/:id" element={<EditStore/>}/>
      <Route path="/invoice/order/:id" element={<Invoice />} />
    </>
  );
};
export default userRoutes;
